/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const EventCard = (props) => {
    const event = props?.event || {};
    const date = event?.date;
    const showDescription = props?.showDescription || false;
    const title = event?.title;
    const startTime = event?.start_time;
    const endTime = event?.end_time;
    const description = event?.description;
    const timezone = event?.timezone;
    const dateMonth = date ? new Date(date + "T00:00:00").toLocaleDateString("en-US", { month: "short" }) : ""; 
    const dateDay = date ? new Date(date + "T00:00:00").getDate().toString() : "";


    return (
        <div className="event-item">
            <div className="event-date">
                <div className="event-date-month">{dateMonth}</div>
                <div className="event-date-day">{dateDay}</div>
            </div>
            <div className="event-content">
                <div className="event-title-content">
                    <div className="event-title">{title}</div>
                    <div className="event-time">{startTime} - {endTime}</div>
                </div>
                {showDescription && (
                    <div className="event-description-content">
                        <div className="event-description">{description}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

EventCard.displayName = "EventCard";
export { EventCard };

